/**
 * StudentNameDisplay component
 * Displays student name with 20-character truncation
 * Follows the PebblesDisplay inline display pattern
 */

import { cn } from '@/lib/utils';

export interface StudentNameDisplayProps {
  /** Student display name from UserProfile */
  name: string;
  /** Optional override classes */
  className?: string;
}

/**
 * StudentNameDisplay - Displays student name with truncation at 20 characters
 * Shows full name in title attribute for hover tooltip
 */
export function StudentNameDisplay({ name, className }: StudentNameDisplayProps) {
  // Truncate name if longer than 20 characters
  const displayName = name && name.length > 20 ? name.slice(0, 20) + '...' : name || '';

  return (
    <span
      className={cn('text-sm font-medium text-otter-earth-800 whitespace-nowrap', className)}
      title={name}
      aria-label={name}
    >
      {displayName}
    </span>
  );
}
